export const hamburgerStyle = {
    position: "fixed",
    color: "white",
    fontSize: "2.8rem",
    top: "2%",
    right: "5%",
    zIndex: 1,
  }